/**
 * Simple Day/Night Image Block - Frontend Script
 * 
 * Handles the toggle between day and night image layers.
 */

import { createBlockInit } from '../../src/js/utils/block-init.js';

function initDayNightImage(blockElement) {
	const toggle = blockElement.querySelector('[data-day-night-toggle]');
	const dayLayer = blockElement.querySelector('.day-night-image__layer--day');
	const nightLayer = blockElement.querySelector('.day-night-image__layer--night');

	if (!toggle || !dayLayer || !nightLayer) {
		return;
	}

	let isNight = false;

	toggle.addEventListener('click', () => {
		isNight = !isNight;

		toggle.setAttribute('aria-pressed', String(isNight));
		blockElement.classList.toggle('is-night', isNight);

		dayLayer.classList.toggle('is-active', !isNight);
		nightLayer.classList.toggle('is-active', isNight);
	});
}

const { initAll: initDayNightImages } = createBlockInit('[data-day-night-block]', initDayNightImage);

export { initDayNightImages, initDayNightImage };
